import api from "@checkout/services/api";
import localStorage from "@checkout/services/storage";
import router from "@checkout/router";
import { store } from '@checkout/store/store';
import { transformErrors } from '@checkout/services/errors';

export default {
    name: 'Register',

    data() {
        return {
            appendedClass: '',
            form: {
                username: '',
                username_confirmation: '',
                password: '',
                password_confirmation: '',
            },
            errors: {},
        }
    },

    methods: {
        submitData() {
            store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");

            api.post('/public-api/new-customer', this.form).then(() => {
                store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

                localStorage.save('token', null, true);
                router.push('/checkout/4');
            })
                .catch(error => {
                    store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

                    if (error.response.status === 422) {
                        this.errors = transformErrors(error.response.data.errors);
                    } else if (error.response.status === 400) {
                        this.$swal(error.response.data.message);
                    } else {
                        this.$swal(this.$i18nApi.t('messages.error'));
                    }
                })
        }
    }
}
